import {
  Box,
  Tab,
  Tabs,
  Stack,
  Typography,
  Select,
  MenuItem,
  Chip,
  OutlinedInput,
} from "@mui/material";
import React, { useContext, useEffect, useMemo, useState } from "react";
import PlantModuleNav from "../../../../../components/PlantModuleNav";
import TabPanel2 from "../../../../../components/widgets/TabPanel2";
import NewViewProject from "../../../../admin/ViewProject2";
import {
  fullPageBoxStyle,
  verticalTabStyle,
} from "../../../../../styles/muiProps";
import ITPTable from "./ITP";
import PunchList from "./Punchlist";
import { useParams } from "react-router-dom";
import PCSTable from "./Table";
import NavTabs from "../../../../../components/Tabs/NavTabs";
import FabricationTab from "./Fabrication";
import ProjectTasksPage from "../../../Project/allProjectsPage/ProjectsTable/ProjectTasksPage";
import PlantTasksWrapper from "../../../Project/plant/PlantTaskPage/PlantTasksWrapper";
import { usePCS } from "./PCSContext";
import FilterListIcon from "@mui/icons-material/FilterList";
import SCurve from "../DCSTab/Tasks/SCurve";
import useDocumentTitle from "../../../../../hooks/useDocumentTitle";
import PageHeader from "../../../../../components/PageHeader";

const PCS = ({ plant = false }) => {
  useDocumentTitle("PCS");

  const { projectId, equipId, plantId } = useParams();
  const {
    plantProjects,
    fabricationData,
    projectFilter,
    setProjectFilter,
    SrvOptions,
    selectedSrvs,
    setSelectedSrvs,
    itpData,
    plantName,
  } = usePCS();

  const projectOptions = useMemo(() => {
    if (!plant) return [];

    const normalized =
      plantProjects && plantProjects.length > 0
        ? plantProjects
            .filter((proj) => proj?.id || proj?.name)
            .map((proj) => ({
              value: String(proj?.id ?? proj?.name),
              label: proj?.name || "Unnamed Project",
            }))
        : [];

    const uniqueMap = new Map();
    normalized.forEach((opt) => {
      if (!opt.value) return;
      if (!uniqueMap.has(opt.value)) {
        uniqueMap.set(opt.value, opt);
      }
    });

    return Array.from(uniqueMap.values());
  }, [plant, plantProjects]);

  useEffect(() => {
    if (!plant) {
      setProjectFilter([]);
      return;
    }
    // Remove invalid project IDs from filter if they no longer exist
    if (projectOptions.length > 0 && projectFilter.length > 0) {
      const validFilters = projectFilter.filter((filterId) =>
        projectOptions.some((option) => option.value === filterId),
      );
      if (validFilters.length !== projectFilter.length) {
        setProjectFilter(validFilters);
      }
    }
  }, [plant, projectOptions, projectFilter]);

  const fabricationCatList = [
    { title: "FINAL PREPARATION" },
    { title: "HYDROSTATIC TEST" },
    { title: "PWHT & NDE POST PWHT" },
    { title: "MANUFACTURING & NDE" },
    { title: "FAB of Nozzles" },
    { title: "FAB of Attachments" },
    { title: "FAB of Shells" },
    { title: "FAB of Pipes" },
  ];

  const tabs = [
    {
      label: "Fabrication",
      moduleKey: "pcs-fabrication",
      panel: <FabricationTab plant={plant} projectFilter={projectFilter} />,
    },
    {
      label: "ITP ",
      moduleKey: "pcs-itp",
      panel: (
        <ITPTable
          plant={plant}
          plantId={plantId}
          projectFilter={projectFilter}
        />
      ),
    },
    {
      label: "4D Schedule",
      moduleKey: "schedule",
      panel: plant ? (
        <PlantTasksWrapper type={"fabrication"} />
      ) : (
        <ProjectTasksPage catList={fabricationCatList} plant={plant} />
      ),
    },
    // {
    //   label: "S-Curve",
    //   panel: <SCurve plant={plant} documentList={fabricationCatList} taskType="fabrication" />,
    // },
  ];
  console.log("from CMS plant:", plant);
  return (
    <Box
      sx={{
        flexGrow: 1,
        bgcolor: "background.paper",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        "& .Mui-disabled": {
          color: "red",
          "-webkit-text-fill-color": "#000000",
        },
      }}
      // {...fullPageBoxStyle}
    >
      {/* <Select
          value={projectFilter}
          onChange={(event) => setProjectFilter(event.target.value)}
          displayEmpty
          inputProps={{ "aria-label": "Select Project" }}
          // sx={{ width: 220, backgroundColor: "var(--app-surface)", height: 40 }}
        >
          <MenuItem value="all">All Projects</MenuItem>
          {projectOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select> */}

      <PageHeader
        plant={{ id: plantId, name: plantName }}
        pageTitle="CMS (Construction Management System)"
        moduleKey="pcs"
      />
      {plant && (
        <Stack
          direction={"row"}
          spacing={2}
          sx={{
            alignItems: "center",
            flexWrap: "wrap",
            justifyContent: "space-between",
            px: 2,
            py: 1,
          }}
        >
          {/* <FilterListIcon color="secondary" /> */}

          {/* <Select
            multiple
            value={projectFilter}
            onChange={(event) => {
              const value = event.target.value;
              setProjectFilter(
                typeof value === "string" ? value.split(",") : value,
              );
            }}
            input={<OutlinedInput label="Select Sub Projects" />}
            renderValue={(selected) => {
              if (selected.length === 0) {
                return <em>All Projects</em>;
              }
              return (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {selected.map((value) => {
                    const option = projectOptions.find(
                      (opt) => opt.value === value,
                    );
                    return (
                      <Chip
                        key={value}
                        label={option?.label || value}
                        size="small"
                      />
                    );
                  })}
                </Box>
              );
            }}
            displayEmpty
            inputProps={{ "aria-label": "Select Sub Projects" }}
            sx={{ minWidth: 300, backgroundColor: "var(--app-surface)" }}
          >
            {projectOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select> */}
          {/* ------------------------------------------------------------ */}
          {/* <Typography variant="h6" color="darkBlue">
            Select SRVs:
          </Typography>
          <Select
            multiple
            value={selectedSrvs}
            onChange={(event) => {
              const value = event.target.value;
              setSelectedSrvs(
                typeof value === "string" ? value.split(",") : value,
              );
            }}
            input={<OutlinedInput label="Add SRV to Fabrication" />}
            renderValue={(selected) => {
              if (selected.length === 0) {
                return <em>All SRVs</em>;
              }
              return (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {selected.map((value) => {
                    const option = projectOptions.find(
                      (opt) => opt.value === value,
                    );
                    return (
                      <Chip
                        key={value}
                        label={option?.label || value}
                        size="small"
                      />
                    );
                  })}
                </Box>
              );
            }}
            displayEmpty
            sx={{ minWidth: 300, backgroundColor: "var(--app-surface)" }}
          >
            {SrvOptions.map((option) => (
              <MenuItem key={option.id} value={option.srvNumber}>
                {option.srvNumber}
              </MenuItem>
            ))}
          </Select> */}
          {/* -------------------------------------------- */}
          {projectFilter.length > 0 && (
            <Typography variant="body2" color="text.secondary">
              {projectFilter.length} project
              {projectFilter.length !== 1 ? "s" : ""} selected
            </Typography>
          )}
        </Stack>
      )}

      <NavTabs tabs={tabs} navLabel="pcs-tab" />

      {/* <Tabs
        orientation="vertical"
        value={tab}
        onChange={handleChange}
        {...verticalTabStyle}
      >
        <Tab label="RACI" />
        <Tab label="Fabrication" />
        <Tab label="ITP" />
        <Tab label="Punch List" />
        <Tab label="Procedures" />
      </Tabs>
      <TabPanel2 value={tab} index={0}>
        <PCSTable projectId={projectId || ""} type="RACI" />
      </TabPanel2>
      <TabPanel2 value={tab} index={1}>
        <PCSTable projectId={projectId || ""} type="Fabrication" />
      </TabPanel2>
      <TabPanel2 value={tab} index={2} p={1}>
        <PCSTable projectId={projectId || ""} type="ITP" />
      </TabPanel2>
      <TabPanel2 value={tab} index={3} p={1}>
        <PCSTable projectId={projectId || ""} type="PunchList" />
      </TabPanel2>
      <TabPanel2 value={tab} index={4} p={1}>
        <PCSTable projectId={projectId || ""} type="Procedures" />
      </TabPanel2>
        <PunchList equipID={equipId} />
      </TabPanel2> */}
    </Box>
  );
};

export default PCS;
